import { ComponentProps, FC, useEffect } from "react";

export const withHelmet = (Component: FC, isNotFound = false) => {
  return (props: ComponentProps<typeof Component>) => {
    useEffect(() => {
      document.title = isNotFound ? "ページが見つかりません" : "QRチェックイン";
    }, []);

    return <Component {...props} />;
  };
};
